/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import SettingsWrapper from '../settings/SettingsWrapper.vue';
import NotificationsView from './components/NotificationsView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/notifications'),
    component: SettingsWrapper,
    children: [
      {
        path: '',
        name: 'notifications_index',
        component: NotificationsView,
        meta: {
          permissions: [
            'administrator',
            'agent',
            'client',
            'custom_role',
            'moderator',
          ],
          // ACESSO-01 (L8b): de todo membro da conta, como as notificações no servidor (`DA_PROPRIA_PESSOA`).
          escopos: [],
        },
      },
    ],
  },
];
